export class ContratoSegurosEntity{
    constructor(
        public CIU_COD ?: number,
        public UNI_COD ?: number,
        public CTR_COD ?: number,
        public CTR_RUC ?: string,
        public CTR_NOM ?: string,
        public CTR_DIR ?: string,
        public CTR_TEL ?: string,
        public CTR_CON ?: string,
        public CTR_MAIL ?: string,
        public CTR_EST ?: number,
        public CTR_CON2 ?: string,
        public CTR_MAIL2 ?: string,
        public CTR_TEL_MOV ?: string,
        public CTR_CAR_CON ?: string,
        public CTR_CAR_CON2 ?: string,
        public CTR_CON_CLI ?: string,
        public CTR_SEG_COD?:  number,
        public CTR_MAIL_CLI?:  string,
        public CON_COD?:  number,
        public CON_NUM?:  string,
        public CLI_COD?:  number,
        public CON_DES?:  string,
        public CON_EST?:  number,
        public CON_FEC_INI?:  Date,
        public CON_FEC_FIN?:  Date,
        public CON_REQ_SEG?:  number,
        public RAM_COD?:  string,
        public CON_POL_FIN?:  Date,
        public CON_POL_EST?:  number,
        public CON_OBS?:  string,
        public CTR_VAL_CON?:  number,
        public CTR_NUM_POL?:  string,
        public ASE_COD?:  number,
        public CTR_VAL_ASG?:  number,
        public CTR_PRI_NET?:  number,
        public CTR_PRI_TOT?:  number,
        public NOT_COD?:  number,
        public CON_NUM_INT?:  string,
        public CTR_PER_ENC?:  string,
        public CTR_TIP_CON?:  number,
        public CTR_FEC_VIG_POL?:  Date,
        public CTR_TIP_MOV?:  number,
        public CTR_POL_EST?:  number,
        public SEG_COD?:  string,
        public CON_EST_ACT?:  number,
        public RAM_NOM?:  string,
        public ASE_NOM?:  string,
        public NOTA_ACLARATORIA?:  string,
        public ESTADO?:  string,
        public TIP_MOVIMIENTO?:  string,
        public ESTADOCONTRATO?:  string 
    ){}
};


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/contrato_seguros_entity.ts